import { TableSource } from '../../common/types/src';

import { TOOLTIPS_TEXTS } from './tooltips';

const homesTableTooltips = TOOLTIPS_TEXTS.homePhotos149Table;

export const BASE_HOME_PHOTOS_149_TABLE_CONFIG: TableSource = {
  displayedColumns: ['date', 'image', 'stage'],
  displayedTitles: ['Date', 'Thumbnail', 'Stage'],
  columnsConfig: [{ sorting: false }, { sorting: false }, { sorting: false }],
  displayedTooltips: [
    homesTableTooltips.date,
    homesTableTooltips.thumbnail,
    homesTableTooltips.stage
  ],
  options: [],
  dataSource: []
};
